<template>
  <div class="col-md-12 p-0 attendance-page">
    <section class="attendance-hero">
      <div>
        <span class="attendance-hero__eyebrow">ATTENDANCE REPORT</span>
        <h2>Attendance Data</h2>
        <p>Pilih kontrak untuk melihat rekap kehadiran dan aktivitas employee.</p>
      </div>
      <div class="attendance-hero__summary">
        <i class="ti ti-calendar"></i>
        <div>
          <strong>{{ data_model.total | formatPrice }}</strong>
          <span>Contracts</span>
        </div>
      </div>
    </section>
    <div class="card attendance-card">
      <div class="card-body">
        <div class="table-header">
          <h5 class="attendance-card__title">
            Contract Attendance <br />
            <small>Daftar kontrak untuk membuka laporan attendance</small>
          </h5>
          <div class="group-search attendance-actions pull-right">
            <a class="btn attendance-icon-btn" title="Refresh data" @click="tableRefresh()"
              ><i class="ti ti-reload"></i
            ></a>
            <a class="btn attendance-icon-btn" title="Search data" @click="isActiveSearch()"
              ><i
                :class="isEnableTools == false ? 'ti ti-search' : 'ti ti-close'"
              ></i
            ></a>
            <div class="select" v-if="isEnableTools">
              <select v-model="meta_data.skey" @change="meta_data.sval = ''">
                <option value="">-- Choose Field --</option>
                <option value="contract.contract_number">Contract Number</option>
                <option value="client.name">Client Name</option>
                <option value="client.office_address">Office Address</option>
                <option value="contract.status">Contract Status</option>
                <option value="contract.start_date">Contract Start Date</option>
                <option value="contract.end_date">Contract End Date</option>
              </select>
            </div>
            <div class="group" v-if="isEnableTools">
              <select
                v-model="meta_data.sval"
                v-if="meta_data.skey == 'contract.status'"
              >
                <option value="">-- Choose Status --</option>
                <option value="draft">Draft</option>
                <option value="complete">Complete</option>
                <option value="on_going">On Going</option>
                <option value="finished">Finished</option>
                <option value="terminate">Terminate</option>
              </select>
              <input
                type="date"
                v-model="meta_data.sval"
                @keyup.enter="tableSearch()"
                v-else-if="
                  meta_data.skey == 'contract.start_date' ||
                  meta_data.skey == 'contract.end_date'
                "
              />
              <input
                type="search"
                v-model="meta_data.sval"
                @keyup.enter="tableSearch()"
                placeholder="Enter Keyword ...."
                v-else
              />
              <a class="btn attendance-search-btn" @click="tableSearch()">
                <i class="ti ti-search"></i> Search
              </a>
            </div>
            <router-link
              :to="{ name: 'jobcon/contract-store' }"
              class="btn"
              v-if="$store.state.app.access.includes('insert')"
              ><i class="ti ti-plus"></i> Create New</router-link
            >
          </div>
          <div class="group-filter attendance-filter" v-if="isRoot">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label>Branch Station</label>
                  <SelectBranch v-on:processBranch="processBranch" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="table-cover attendance-table-cover">
          <table class="table-hover">
            <thead>
              <tr>
                <th
                  width="70"
                  class="no-filter"
                  v-if="$store.state.app.access.includes('detail')"
                >
                  Action
                </th>
                <th
                  :class="
                    meta_data.okey == 'contract.contract_number' ? 'active' : ''
                  "
                  v-on:click="tableOrdering('contract.contract_number')"
                >
                  Contract Number
                </th>
                <th
                  :class="meta_data.okey == 'client.name' ? 'active' : ''"
                  v-on:click="tableOrdering('client.name')"
                >
                  Client Name
                </th>
                <th
                  :class="
                    meta_data.okey == 'contract.start_date' ? 'active' : ''
                  "
                  v-on:click="tableOrdering('contract.start_date')"
                >
                  Contract Period
                </th>
                <th
                  :class="
                    meta_data.okey == 'contract.man_power' ? 'active' : ''
                  "
                  v-on:click="tableOrdering('contract.man_power')"
                >
                  Total Man Power
                </th>
              </tr>
            </thead>
            <tbody v-if="data_model.total > 0">
              <tr v-for="(items, idx) in data_model.data" :key="idx">
                <td
                  width="150"
                  v-if="$store.state.app.access.includes('detail')"
                >
                  <a class="attendance-detail-btn" href="javascript:;" @click="DetailAttendance(items.id)"
                    ><i class="ti ti-time"></i> View Attendance</a
                  >
                </td>
                <td width="180"><strong class="contract-number">{{ items.contract_number }}</strong></td>
                <td width="350">
                  <b>{{ items.client_name }}</b
                  ><br />
                  <small class="text-secondary"
                    >{{ items.office_address }}, {{ items.nama_provinsi }} -
                    {{ items.nama_kota }}</small
                  >
                </td>
                <td class="pr-3">
                  <span :class="items.status | contractStatus">{{
                    items.status | cleanString
                  }}</span>
                  <br />
                  {{ items.start_date | moment("DD/MM/YYYY") }} -
                  {{ items.end_date | moment("DD/MM/YYYY") }}
                </td>
                <td class="pr-3">
                  <span class="text-danger">{{
                    GetTotalManPower(items.man_power)
                  }}</span>
                  - Employee
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="5">
                  <div class="no-data" v-if="!$store.state.loading.status">
                    Sorry data is not available
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pagination attendance-pagination">
          <small class="info"
            ><i class="ti ti-split-h"></i> Scroll horizontal to view
            data.</small
          >
          <paginate
            v-if="pageCount > 1"
            :page-count="pageCount"
            :force-page="page"
            :click-handler="tableQuery"
            :container-class="'pagination'"
            :page-class="'page-item'"
          >
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import router from "../../../router";
import PopupDetailContract from "../../JobContract/@PopupDetailContract";
import { mapState } from "vuex";
import MixServerDate from "../../../mixin/mix_serverdate.js";
import SelectBranch from "../../Branch/@SelectBranch";

export default {
  mixins: [MixServerDate],
  data() {
    return {
      isRoot: false,

      isEnableTools: false,
      isEnableOrder: false,
      id_contract: null,
      page: 1,

      meta_url: "contract",
      meta_data: {
        okey: "created_at",
        oval: "desc",
        wkey: "",
        wval: "",
        skey: "",
        sval: "",
      },
      meta_filter: { id_branch: "all" },
    };
  },
  components: {
    PopupDetailContract,
    SelectBranch,
  },
  computed: {
    ...mapState("crud", {
      data_model: (state) => state.data_model,
      msg_error: (state) => state.error,
    }),
    pageCount() {
      return parseInt(this.data_model.last_page, 10) || 0;
    },
  },
  created() {
    const roleUserPrivilegesName = ["root", "hrd nasional"];

    // filter branch
    if (
      !roleUserPrivilegesName.includes(
        localStorage.getItem("userPrivilegesName")
      )
    ) {
      this.meta_filter.id_branch = localStorage.getItem("userBranchId");
    } else {
      this.isRoot = true;
    }
    this.tableQuery(1);
  },
  methods: {
    processBranch(data) {
      this.meta_filter.id_branch = data;
      this.tableQuery(1);
    },
    isActiveSearch() {
      this.isEnableTools = !this.isEnableTools;
      if (this.isEnableTools) this.meta_data.sval = "";
    },
    GetTotalManPower(data) {
      let res = JSON.parse(data);
      let total = 0;
      for (let key in res) {
        total = total + parseInt(res[key].total);
      }
      return total;
    },
    tableSearch() {
      this.meta_data.sval = String(this.meta_data.sval).trim();
      if (this.meta_data.skey == "") {
        alert("🙏, Please choose target field");
        return;
      }
      if (this.meta_data.sval == "") {
        alert("🙏, Please enter the keyword");
        return;
      }
      this.tableQuery(1);
    },
    tableOrdering(key) {
      this.isEnableOrder = !this.isEnableOrder;
      this.meta_data.okey = key;
      this.meta_data.oval = this.isEnableOrder ? "ASC" : "DESC";
      this.tableQuery(1);
    },
    tableQuery(pageNum) {
      this.page = parseInt(pageNum, 10) || 1;
      let data = {
        url: this.meta_url + "/report-list",
        offset: this.page,
        search: { key: this.meta_data.skey, value: this.meta_data.sval },
        order: { key: this.meta_data.okey, value: this.meta_data.oval },
        where: { key: this.meta_data.wkey, value: this.meta_data.wval },
        filter: [
          { key: "contract.id_branch", val: this.meta_filter.id_branch },
          {
            key: "contract-station",
            val: localStorage.getItem("userContract"),
          },
        ],
      };

      this.$store.state.loading.msg = "Processing Fetching Data...";
      this.$store.state.loading.status = true;
      this.$store.dispatch("crud/getData", data);
    },
    tableRefresh() {
      this.meta_data.skey = "";
      this.meta_data.sval = "";
      this.meta_data.okey = "created_at";
      this.meta_data.oval = "desc";
      this.isEnableOrder = false;
      this.$store.state.loading.msg = "Refreshing Data...";
      this.$store.state.loading.status = true;
      this.tableQuery(1);
    },
    DetailAttendance(id) {
      localStorage.setItem("QUERY_ID", id);
      router.push({ name: "report/attendance-detail" });
    },
  },
};
</script>
<style scoped>
.attendance-page { color: #344a58; }
.attendance-hero {
  align-items: center;
  background: linear-gradient(120deg, #326f9c 0%, #3193a7 58%, #55b9b8 100%);
  border-radius: 14px;
  box-shadow: 0 10px 25px rgba(45, 111, 145, 0.16);
  color: #fff;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  min-height: 150px;
  overflow: hidden;
  padding: 25px 28px;
  position: relative;
}
.attendance-hero::after {
  background: rgba(255,255,255,.08);
  border-radius: 50%;
  content: "";
  height: 210px;
  position: absolute;
  right: -55px;
  top: -95px;
  width: 210px;
}
.attendance-hero__eyebrow { color: #c7f4eb; font-size: 11px; font-weight: 700; letter-spacing: 1.2px; }
.attendance-hero h2 { color: #fff; font-size: 24px; font-weight: 700; margin: 5px 0 6px; }
.attendance-hero p { color: rgba(255,255,255,.82); margin: 0; }
.attendance-hero__summary {
  align-items: center;
  background: rgba(255,255,255,.14);
  border: 1px solid rgba(255,255,255,.25);
  border-radius: 12px;
  display: flex;
  min-width: 160px;
  padding: 12px 18px;
  position: relative;
  z-index: 1;
}
.attendance-hero__summary i { font-size: 26px; margin-right: 13px; }
.attendance-hero__summary strong, .attendance-hero__summary span { display: block; }
.attendance-hero__summary strong { font-size: 22px; line-height: 1.1; }
.attendance-hero__summary span { color: rgba(255,255,255,.78); font-size: 11px; margin-top: 2px; }
.attendance-card { border: 1px solid #e5ebf1; border-radius: 14px; box-shadow: 0 10px 28px rgba(41,72,105,.07); overflow: hidden; }
.attendance-card > .card-body { padding: 26px; }
.attendance-card__title { color: #2d4452; font-weight: 700; }
.attendance-card__title small { color: #8295a2; font-size: 12px; font-weight: 400; }
.attendance-actions { align-items: center; display: flex; flex-wrap: wrap; gap: 7px; }
.attendance-actions .btn { margin: 0; }
.attendance-icon-btn { align-items: center; background: #f4f9fb; border: 1px solid #dce8ed; border-radius: 7px; color: #317f91; display: inline-flex; height: 38px; justify-content: center; min-width: 38px; }
.attendance-search-btn { background: #3193a7; border-radius: 7px; color: #fff; }
.attendance-filter { background: #f7fafc; border: 1px solid #e3eaf1; border-radius: 9px; clear: both; margin-top: 20px; padding: 14px; }
.attendance-filter .form-group { margin: 0; max-width: 280px; }
.attendance-filter label { color: #607683; display: block; font-size: 11px; font-weight: 700; margin-bottom: 7px; text-transform: uppercase; }
.attendance-table-cover { border: 1px solid #e2e9ef; border-radius: 10px; margin-top: 20px; overflow-x: auto; }
.attendance-table-cover table { margin: 0; min-width: 930px; width: 100%; }
.attendance-table-cover thead th { background: #edf6f8; color: #466071; font-weight: 600; }
.attendance-table-cover tbody tr:hover { background: #f5fbfb; }
.attendance-detail-btn { align-items: center; background: #eaf7f5; border: 1px solid #c4e6e0; border-radius: 6px; color: #287a70; display: inline-flex; font-size: 11px; font-weight: 600; gap: 6px; padding: 7px 9px; white-space: nowrap; }
.attendance-detail-btn:hover { background: #d9efeb; color: #236c64; }
.contract-number { color: #315f78; font-weight: 600; }
.attendance-pagination { align-items: center; display: flex; justify-content: space-between; margin-top: 18px; width: 100%; }
.attendance-pagination::v-deep ul.pagination { display: flex; gap: 5px; margin: 0; }
.attendance-pagination::v-deep .page-item a { align-items: center; background: #fff; border: 1px solid #d8e3eb; border-radius: 7px; color: #587083; display: flex; height: 34px; justify-content: center; min-width: 34px; padding: 0 9px; }
.attendance-pagination::v-deep .page-item.active a { background: #3193a7; border-color: #3193a7; box-shadow: 0 5px 12px rgba(49,147,167,.25); color: #fff; font-weight: 700; }
.attendance-pagination::v-deep .page-item a:hover { background: #eaf6f7; border-color: #72bdc5; color: #276d7b; }
@media (max-width: 767px) {
  .attendance-hero { align-items: stretch; flex-direction: column; min-height: 132px; padding: 22px 20px; }
  .attendance-hero__summary { margin-top: 18px; width: 100%; }
  .attendance-card > .card-body { padding: 16px; }
  .table-header { display: flex; flex-direction: column; }
  .attendance-actions { margin-top: 14px; width: 100%; }
  .attendance-actions .select, .attendance-actions .group { width: 100%; }
  .attendance-actions .select select, .attendance-actions .group input, .attendance-actions .group select { width: 100%; }
  .attendance-filter .form-group { max-width: none; width: 100%; }
  .attendance-pagination { align-items: flex-start; flex-direction: column; gap: 12px; }
  .attendance-pagination::v-deep ul.pagination { flex-wrap: wrap; }
}
</style>
